import { createServerFn } from '@tanstack/react-start';

import type { LastActiveDashboard } from './last-active-dashboard-cookie';

import { readLastActiveDashboard } from './last-active-dashboard-cookie';

/**
 * The workspace this researcher last used, if we remember one.
 *
 * A server function because the cookie is `httpOnly` and `beforeLoad` may run
 * on the client. It reports what was remembered and nothing more: the caller
 * checks the pair against the researcher's own memberships, and
 * `persistActiveDashboard` enforces membership again before writing anything.
 * A remembered id is a hint, never an authorization.
 *
 * `userId` is passed in rather than re-derived from the session. Deriving it
 * here cost a Redis read plus a core-api `fetchUser` on every resume, to learn
 * an id the caller already holds. Nothing is leaked by trusting the argument:
 * the cookie belongs to this browser either way, and the id is only used to
 * reject a value written for a different account (a shared machine), so
 * passing someone else's id yields `null` rather than their workspace.
 */
export const readRememberedDashboard = createServerFn()
  .validator((data: { userId: string }) => data)
  .handler(({ data: { userId } }): LastActiveDashboard | null =>
    readLastActiveDashboard(userId),
  );
